module.exports = __webpack_public_path__ + "static/media/m_eyeshape_round_grey.fda17a65.png";